import gql from 'graphql-tag';

export default gql`
  query {
    userAddresses {
      id
      label
      street
      city
      state
      zipcode
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components_new/addresses/getAddressQ.js